import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bemGenerator } from '@prisjakt/ui-base';
import PanelHeader from '@prisjakt/ui-panel-header';
import { AppContext } from '@prisjakt/ui-app-context';

import settingActions from '../../actions/settings';
import usernameActions from '../../actions/username';
import displayNameActions from '../../actions/display-name';
import emailActions from '../../actions/email';
import passwordActions from '../../actions/password';
import InputValueSetting from '../input-value-setting';
import PasswordSetting from '../password-setting';

import './index.scss';

const styles = bemGenerator('settings-profile', ['setting']);

class ProfileSettings extends React.PureComponent {
  componentWillUnmount() {
    // Resets editing mode
    this.props.startEditing();
  }

  onStartEditing = (type = null) => () => this.props.startEditing(type);

  onChangePassword = data =>
    this.props.passwordChange({
      currentPassword: data.currentPassword,
      newPassword: data.newPassword,
    });

  onChangeEmail = data =>
    this.props.emailChange({
      email: data,
    });

  onChangeDisplayName = data =>
    this.props.displayNameChange({
      displayName: data,
    });

  shouldShowPasswordSetting = () =>
    !(this.props.socialNetworks && this.props.socialNetworks.length);

  render() {
    const { t } = this.context;
    const { email, displayName, editing, errors, saving } = this.props;
    return (
      <div className={styles.block}>
        <PanelHeader
          title={t('account', 'settings.account-header')}
          margin="bottom"
        />
        <div>
          <div className={styles.setting}>
            <InputValueSetting
              label={t('account', 'input.display-name')}
              editable={!editing}
              editing={editing === 'displayName'}
              value={displayName}
              error={t('errors', errors.displayName)}
              saving={saving}
              onStartEditing={this.onStartEditing('displayName')}
              onStopEditing={this.onStartEditing()}
              onChange={this.onChangeDisplayName}
              minLength={3}
              maxLength={50}
            />
          </div>
          <div className={styles.setting}>
            <InputValueSetting
              label={t('account', 'input.email')}
              editable={!editing}
              editing={editing === 'email'}
              value={email}
              error={t('errors', errors.email)}
              saving={saving}
              onStartEditing={this.onStartEditing('email')}
              onStopEditing={this.onStartEditing()}
              onChange={this.onChangeEmail}
            />
          </div>
          <div className={styles.setting}>
            <PasswordSetting
              label={t('account', 'input.password')}
              editable={!editing}
              editing={editing === 'password'}
              error={t('errors', errors.password)}
              saving={saving}
              onStartEditing={this.onStartEditing('password')}
              onStopEditing={this.onStartEditing()}
              onChange={this.onChangePassword}
            />
          </div>
        </div>
      </div>
    );
  }
}

ProfileSettings.propTypes = {
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string,
  socialNetworks: PropTypes.arrayOf(PropTypes.string),
  editable: PropTypes.bool,
  editing: PropTypes.string,
  errors: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
  }),
  saving: PropTypes.bool,
  emailChange: PropTypes.func.isRequired,
  passwordChange: PropTypes.func.isRequired,
  usernameChange: PropTypes.func.isRequired,
  displayNameChange: PropTypes.func.isRequired,
  startEditing: PropTypes.func.isRequired,
};

ProfileSettings.defaultProps = {
  password: '',
  socialNetworks: null,
  errors: {},
  editable: true,
  editing: undefined,
  saving: false,
};

ProfileSettings.contextType = AppContext;

export default connect(
  state => ({
    ...state.areas.account.me,
    ...state.areas.account.settings,
  }),
  {
    ...settingActions,
    ...usernameActions,
    ...displayNameActions,
    ...emailActions,
    ...passwordActions,
  }
)(ProfileSettings);
